package com.essntl.features.service.ui.allservice

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.ui.allservice.components.*
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.delay

@Composable
fun AllServiceScreen(
    state: AllServiceState,
    onEvent: (AllServiceEvent) -> Unit,
    onNavigation: (AllServiceNavigation) -> Unit,
    allSuppliersState: AllSuppliersState,
    onEventAllSupplier: (AllSuppliersEvent) -> Unit,
    isSidePanelOpen: Boolean,
) {
    var searchText by remember { mutableStateOf("") }

    LaunchedEffect(searchText) {
        delay(500L)
        onEvent(
            AllServiceEvent.EditFilterOptions(
                state.filterOptions.copy(
                    searchText = searchText,
                ),
            ),
        )
    }

    Column(
        modifier = Modifier
            .fillMaxSize(),
    ) {
        AllServiceHeader(
            state = state,
            isSidePanelOpen = isSidePanelOpen,
            onAddService = {
                onNavigation(AllServiceNavigation.AddService())
            },
            searchText = searchText,
            onSearchTextChange = {
                searchText = it
            },
        )

        Spacer(modifier = Modifier.height(1.spacing))

        AllServiceFilterSection(
            state = state,
            allSuppliersState = allSuppliersState,
            onEventAllSupplier = onEventAllSupplier,
            onCategorySelected = { onEvent(AllServiceEvent.SelectCategory(it)) },
            onFilterOptionsChange = {
                onEvent(AllServiceEvent.EditFilterOptions(it))
                if (it == ServiceFilterOptions()) {
                    searchText = ""
                    onEvent(AllServiceEvent.SelectCategory(null))
                }
            },
        )

        if (state.getAllService.data.isEmpty())
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 1.spacing)
                    .height(200.dp)
                    .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                    .background(MaterialTheme.esColorScheme.bgSecondary),
            ) {
                if (state.getAllService.isLoading)
                    EsSpinner()
                else if (state.getAllService.isFailure)
                    Text(
                        text = "Something goes wrong!",
                        color = MaterialTheme.esColorScheme.textSecondary,
                        style = MaterialTheme.esTypography.p1Medium16,
                    )
                else if (state.getAllService.data.isEmpty())
                    Text(
                        text = "No services found!",
                        color = MaterialTheme.esColorScheme.textSecondary,
                        style = MaterialTheme.esTypography.p1Medium16,
                    )
            }
        else
            ServicesGrid(
                state = state,
                onNavigation = onNavigation,
                onEvent = onEvent,
                modifier = Modifier.weight(1f),
            )
    }
}
